module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (235).5c7b3221.jpg";